import Scrollbars from './view';

export type { ScrollbarsRef, ScrollValues } from './view';

export default Scrollbars;
